export enum DatasetConditionOperator {
    None = -1,
    Equal = 0,
    NotEqual = 1,
    GreaterThan = 2,
    LessThan = 3,
    GreaterEqual = 4,
    LessEqual = 5,
    Like = 6,
    NotLike = 7,
    In = 8,
    NotIn = 9,
    Null = 12,
    NotNull = 13,
    Yesterday = 14,
    Today = 15,
    Tomorrow = 16,
    Last7Days = 17,
    Next7Days = 18,
    LastWeek = 19,
    ThisWeek = 20,
    LastMonth = 22,
    ThisMonth = 23,
    On = 25,
    OnOrBefore = 26,
    OnOrAfter = 27,
    LastYear = 28,
    ThisYear = 29,
    LastXDays = 33,
    NextXDays = 34,
    LastXMonths = 37,
    NextXMonths = 38,
    Contains = 49,
    BeginWith = 54,
    DoesNotBeginWith = 55,
    EndsWith = 56,
    DoesNotEndWith = 57,
    InFiscalPeriodAndYear = 70,
    Above = 75,
    Under = 76,
    NotUnder = 77,
    AboveOrEqual = 78,
    UnderOrEqual = 79,
    ContainValues = 87,
    DoesNotContainValues = 88
  }